<template>
  <div>
    <v-tooltip
      v-show="params.showIcon"
      :top="tooltipOnTop"
      :bottom="tooltipOnBottom"
      :max-width="tooltipMaxWidth" 
      :nudge-right="tooltipNudgeRight"
      :nudge-left="tooltipNudgeLeft">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" class="mr-1 conditional-icon" v-show="params.showIcon" :color="params.iconColor" small>{{ params.iconCode }}</v-icon>
      </template>
      <span v-show="params.showIcon" v-html="params.tooltip"></span>
    </v-tooltip>
    <span>{{ params.value }}</span>
    <br v-if="params.subValue"/>
    <span v-if="params.subValue" style="font-weight: normal">{{params.subValue}}</span>
  </div>
</template>

<script>
  export default {
    name: 'ConditionalIconCellRenderer',
    data() {
    },
    methods: {
    },
    computed: {
      tooltipMaxWidth() {
        return this.params.tooltipMaxWidth || '500px';
      },
      tooltipOnTop() {
        return this.params.tooltipOnTop || false;
      },
      tooltipOnBottom() {
        if (this.tooltipOnTop) {
          return false;
        }
        return this.params.tooltipOnBottom || true;
      },
      tooltipNudgeRight() {
        return this.params.tooltipNudgeRight || 0;
      },
      tooltipNudgeLeft() {
        return this.params.tooltipNudgeLeft || 0;
      }
    },
    mounted() {
      //console.log('ConditionalIconCellRenderer'); // uncomment to see how often component is rendering
    }
  }
</script>

<style scoped lang="scss">
  .conditional-icon {
    padding-bottom: 2px;
  }
</style>
